import React from "react";

export default function BlackWhiteButton(props) {
  return (
    <>
      <div
        className={`${props.className !== undefined ? props.className : ""} col-${
          props.size === undefined ? 12 : props.size
        } col-lg-${props.sizeLg} d-flex justify-content-end`}
      >
        <button
          onClick={props.onClick}
          className={`${
            props.classNameButton !== undefined ? props.classNameButton : ""
          } btn btn-white button-white-primary fz-14 px-3 py-2  d-flex justify-content-center align-items-center ff-univanova-regular`}
          type="button"
        >
          {props.text}
        </button>
      </div>
    </>
  );
}
